import http from "@/config/http";

/*************** <LOGS> *********************/
export const createLog = async (data) => http.post(`v1/logs`, data);
/*************** <LOGS/> *********************/